import { motion, useReducedMotion } from "motion/react";

/*
 * THE CopyFi ORB, ONE COMPONENT.
 *
 * Lived inside App.tsx as the login page's logo. Guillaume, 2026-09-22: "we have
 * a Orb that is majestic, could we make replace our AI Orb to make it identical
 * to this one?" -- so the assistant's Orb renders this same component: the
 * rotating sheen, the breathing halo and the float, honouring reduced motion.
 */
/** `still`: no float, for a small Orb inside a button (round 8 #211: the 7 px float left the header button). */
export function LogoOrb({ className = "w-16 h-16 md:w-20 md:h-20", still = false }: { className?: string; still?: boolean }) {
  /* Honoured as it already is in QuickLearnTour and index.css. Vestibular
     disorders are why the setting exists, and a rotating sheen beside text
     someone is reading is exactly what it is set to stop. */
  const reduceMotion = useReducedMotion();

  return (
    <div className={`relative ${className}`}>
      {/* Sheen. Larger than the orb and behind it, so what shows is the light
          moving past the mark rather than a spinning disc. */}
      <motion.div
        aria-hidden
        className="absolute -inset-2 rounded-full"
        style={{
          background:
            "conic-gradient(from 0deg, transparent 0deg, rgba(96,165,250,0.55) 60deg, rgba(167,139,250,0.35) 130deg, transparent 220deg)",
          filter: "blur(6px)",
        }}
        animate={reduceMotion ? undefined : { rotate: 360 }}
        transition={{ duration: 9, repeat: Infinity, ease: "linear" }}
      />

      {/* Halo. */}
      <motion.div
        aria-hidden
        className="absolute -inset-1 rounded-full"
        style={{
          background:
            "radial-gradient(circle, rgba(59,130,246,0.45) 0%, rgba(59,130,246,0.15) 45%, transparent 70%)",
        }}
        animate={reduceMotion ? undefined : { opacity: [0.35, 0.95, 0.35], scale: [0.9, 1.3, 0.9] }}
        transition={{ duration: 3.2, repeat: Infinity, ease: "easeInOut" }}
      />

      <motion.div
        className="relative w-full h-full rounded-full flex items-center justify-center"
        style={{ boxShadow: "0 0 20px 4px rgba(59,130,246,0.12), 0 0 40px 10px rgba(59,130,246,0.06)" }}
        animate={reduceMotion || still ? undefined : { y: [0, -7, 0] }}
        transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
      >
        <img
          src="/copyfilogo.png"
          alt="CopyFi"
          className="w-full h-full object-contain"
        />
      </motion.div>
    </div>
  );
}
